import { useState } from 'react'
import { Button, Form, Modal, TextArea } from 'semantic-ui-react'
import { PropsModalTextArea } from './type'

export const ModalTextArea = (props: PropsModalTextArea) => {
  const [descricao, setDescricao] = useState<string | number>()
  const [open, setOpen] = useState(false)
  const { title, trigger, onClick } = props

  const handleConfirm = () => {
    onClick(descricao)
    setOpen(false)
    setDescricao(undefined)

  }

  const handleClose = () => {
    setOpen(false)
    setDescricao(undefined)
  }

  return <Modal
    onClose={handleClose}
    onOpen={() => setOpen(true)}
    open={open}
    trigger={trigger}
  >
    <Modal.Header>{title}</Modal.Header>
    <Modal.Content>
      <Form>

        <TextArea
          value={descricao}
          placeholder='descrição'
          onChange={(_, { value }) => setDescricao(value)}
          rows={4}
        />
      </Form>
    </Modal.Content>
    <Modal.Actions>
      <Button
        onClick={handleClose}
      >
        Cancelar
      </Button>
      <Button
        primary
        onClick={handleConfirm}
      >
        Enviar
      </Button>
    </Modal.Actions>
  </Modal>
}
